import { API, IdUser } from "./apiConfig";
export const getDashboard = () => {
  return API.post("/UnitContent/Dashboard/UnitContentInformation", {
    IdUser: IdUser,
  });
};
